const Search1 = 'search/';

export const SEARCH_SET_NAME = `${Search1}setRouterName`;
export const SEARCH_GET_VALUE = `${Search1}getRouterValue`;
export const SEARCH_GET_NAME = `${Search1}getRouterName`;
export const SEARCH_TITLE_SEARCH = `${Search1}setTitleSearch`;
export const SEARCH_GET_TITLE_SEARCH_VALUE = `${Search1}getTitleSearch`;

export default {
  namespaced: true,
  state: {
    routerName: '',
    routerTime: '',
    routerValue: '',
    titleSearchTime: '',
    titleSearchValue: [{
      titleSearchKey: '',
      queryDisplayValue: '',
    }],
  },
  mutations: {
    setRouterName: (state, obj) => {
      state.routerName = obj.name;
      state.routerTime = obj.time;
      state.routerValue = JSON.stringify(obj.value);
    },
    setTitleSearch: (state, obj) => {
      state.routerName = obj.name;
      state.titleSearchValue = obj.value;
      state.titleSearchTime = obj.time;
    },
  },
  actions: {},
  modules: {},
  getters: {
    getRouterValue(state) {
      return state.routerValue;
    },
    getRouterName(state) {
      return state.routerName;
    },
    getTitleSearch(state) {
      return state.titleSearchValue;
    },
  },
};
